export const DEFAULT_LANGUAGE = 'de';
export const FALLBACK_LANGUAGE = 'de';
export const SUPPORTED_LANGUAGES = ['de', 'en', 'fr'];
